var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJetski(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_522",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29233",
    "data-name": "Group 29233",
    transform: "translate(435 10673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -435, -10673)",
    filter: "url(#Ellipse_522)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_522-2",
    "data-name": "Ellipse 522",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50351",
    "data-name": "Path 50351",
    d: "M291.717,71.388l2.4,1.387s2.8-.973,3.763-.419l-4.556-2.63A18.937,18.937,0,0,1,291.717,71.388Z",
    transform: "translate(-687.71 -10723.13)",
    fill: "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50352",
    "data-name": "Path 50352",
    d: "M136.9,200.611l-1.213-2.228-1.039.278a1.5,1.5,0,0,0-1.111,1.448V201.7Z",
    transform: "translate(-540.924 -10842.523)",
    fill: "#dd636e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50353",
    "data-name": "Path 50353",
    d: "M184.35,104.174l-3.218-1.858-1.508-.016-.824-1.33a3.06,3.06,0,0,0-3.1.021l-3.351,2-2.028,1.832c0,.006-6.931,1.233-6.931,1.233v4.295l20.88-5.595a.315.315,0,0,0,.076-.578Z",
    transform: "translate(-568.628 -10751.744)",
    fill: "#707dd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50354",
    "data-name": "Path 50354",
    d: "M370.845,107.6l-2.331-1.346-.595,1.03a.665.665,0,0,0,.243.908l.522.3a1.425,1.425,0,0,0,1.946-.521Z",
    transform: "translate(-758.342 -10757.026)",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50355",
    "data-name": "Path 50355",
    d: "M114.382,169.067c2.3,0,2.3.89,4.609.89,2.254,0,2.3-.852,4.462-.889l10.127-2.714a4.241,4.241,0,0,0,3-3l.552-2.06-23.805,6.379.806,1.4Q114.257,169.067,114.382,169.067Z",
    transform: "translate(-522.165 -10808.107)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50356",
    "data-name": "Path 50356",
    d: "M135.427,162.276a4.241,4.241,0,0,1-2.869,2.6l-9.267,2.483a9.63,9.63,0,0,1-1.471.267c-1.582.169-1.832.853-3.851.853a5.91,5.91,0,0,1-2.547-.538l.655,1.135h0v.57l5.5,1.32,3.822-1.892,10.127-2.714a4.241,4.241,0,0,0,3-3l.552-2.06Z",
    transform: "translate(-524.109 -10808.108)",
    fill: "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50357",
    "data-name": "Path 50357",
    d: "M285.473,130.606l2.71,1.564a.556.556,0,1,0,.556-.964l-2.55-1.472-.548.326Z",
    transform: "translate(-681.915 -10778.817)",
    fill: "#5766cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50358",
    "data-name": "Path 50358",
    d: "M89.441,157.187a.556.556,0,0,1-.144-1.094l26.206-7.027a.556.556,0,0,1,.288,1.075l-26.206,7.027A.557.557,0,0,1,89.441,157.187Z",
    transform: "translate(-499.484 -10796.74)",
    fill: "#698ed5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50359",
    "data-name": "Path 50359",
    d: "M135.939,135.414a2.713,2.713,0,0,1-2.575,1.926h-.021l-6.892-.012a1.978,1.978,0,0,1-1.884-1.388.679.679,0,0,1,.649-.881l8.131.015a5.736,5.736,0,0,0,2.946-.808Z",
    transform: "translate(-532.568 -10783.022)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_485",
    "data-name": "Ellipse 485",
    cx: 1.629,
    cy: 1.629,
    r: 1.629,
    transform: "translate(-397.641 -10655)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50360",
    "data-name": "Path 50360",
    d: "M36.87,269.344a.137.137,0,0,0-.14-.137c-2.166.035-2.212.889-4.469.889-2.3,0-2.3-.89-4.609-.89s-2.3.89-4.609.89-2.3-.89-4.609-.89-2.3.89-4.609.89-2.3-.89-4.609-.89-2.3.89-4.609.89c-2.257,0-2.3-.854-4.469-.889a.137.137,0,0,0-.14.137v13.784a.137.137,0,0,0,.137.137h36.6a.137.137,0,0,0,.137-.137V269.344Z",
    transform: "translate(-417 -10908.246)",
    fill: "#d3effb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50361",
    "data-name": "Path 50361",
    d: "M36.73,269.222a7.653,7.653,0,0,0-2.828.678v5.823a6.073,6.073,0,0,1-6.073,6.073H0v1.347a.137.137,0,0,0,.137.137h36.6a.137.137,0,0,0,.137-.137V269.358a.137.137,0,0,0-.14-.137Zm-22.9,5.913a6.082,6.082,0,0,1-2.5-.482,5,5,0,0,0-2.1-.408,5,5,0,0,0-2.1.408,6.082,6.082,0,0,1-2.5.482.556.556,0,0,1,0-1.113,5,5,0,0,0,2.1-.408,6.082,6.082,0,0,1,2.5-.483,6.082,6.082,0,0,1,2.5.483,5,5,0,0,0,2.1.408,5,5,0,0,0,2.1-.408,6.082,6.082,0,0,1,2.5-.483.556.556,0,0,1,0,1.113,5,5,0,0,0-2.1.408,6.083,6.083,0,0,1-2.5.482Z",
    transform: "translate(-417 -10908.261)",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50362",
    "data-name": "Path 50362",
    d: "M203.258,387.557a6.083,6.083,0,0,1-2.505-.483,5.632,5.632,0,0,0-4.208,0,6.743,6.743,0,0,1-5.01,0,5.632,5.632,0,0,0-4.208,0,6.081,6.081,0,0,1-2.5.483.556.556,0,0,1,0-1.113,5,5,0,0,0,2.1-.408,6.743,6.743,0,0,1,5.01,0,5.632,5.632,0,0,0,4.208,0,6.744,6.744,0,0,1,5.01,0,5,5,0,0,0,2.1.408.556.556,0,0,1,0,1.113Z",
    transform: "translate(-587.997 -11016.216)",
    fill: "#b1e4f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetski);
export default __webpack_public_path__ + "static/media/jetski.9404a031be12437233dffb06755383c1.svg";
export { ForwardRef as ReactComponent };